module.exports = __webpack_public_path__ + "img/9.fa8eb11b.jpg";